import React, { useEffect } from "react";
import Header from "../../Components/Header/Header";
import dummy1 from "./SignificanceOfNarasimha/assets/dummy1.jpg";
// import NarasimhaChaturdhashi from "./SignificanceOfNarasimha/assets/Narasimha Chaturdhashi.png";
import NarasimhaChaturdhashi from "./assets/436265320_852c713bf8_c.webp";
// import NityaSeva from "./NityaSevaBlog/assets/Nitya Seva.png";
import NityaSeva from "./assets/0O4A6439.webp";
// import Ekadashi from "./EkadashiImportance/assets/Ekadashi.png";
import Ekadashi from "./assets/0bfb8607a675c43c16a216e05b7377e0.webp";
// import Radhayatra from "./SriJagannathRathYatra/assets/Radhayatra.png";
import Radhayatra from "./assets/0P9A7515.webp";
import SriKrishnaJanmashtami from "./assets/Sri_Krishna_Janmashtami.webp"
import Footer from "../../Components/Footer/Footer";
import { NavLink } from "react-router-dom";
import RecentBlogs from "./RecentBlogs/RecentBlogs";
import "./blogs.css";

const Blogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      <div id="blogs-container">
        <div id="heading-sign">
          <h2>Events</h2>
        </div>

        <main id="main-content">
          {/* Main Section */}
          <div id="main-section">
            <div id="card-grid">
             {/* Sri Krishna Janmashtami  */}
              <div id="card">
                <div className="image-wrapper-blog">
                  <img src={SriKrishnaJanmashtami} alt="Festival" />
                </div>
                <h3>Sri Krishna Janmashtami </h3>
                <p>
                  On August 16, 2025, the city of Vijayawada will witness an
                  extraordinary spiritual celebration – the Sri Krishna
                  Janmashtami Mahotsav at ISKCON Vijayawada....
                </p>
                <NavLink to="/sri-krishna-janmashtami">
                  <button id="read-more-btn">READ MORE</button>
                </NavLink>
              </div>
              <div id="card">
                <div className="image-wrapper-blog">
                  <img src={NarasimhaChaturdhashi} alt="Brahmotsava" />
                </div>
                <h3>Significance-of-Narasimha Chaturdashi</h3>
                <p>
                  Each year, the Vaishnava community around the world reverently
                  ...
                </p>
                <NavLink to="/significance-of-narasimha">
                  <button id="read-more-btn">READ MORE</button>
                </NavLink>
              </div>

              <div id="card">
                <div className="image-wrapper-blog">
                  <img src={NityaSeva} alt="Festival" />
                </div>
                <h3>Nitya Seva</h3>
                <p>
                  Have you ever wondered how beautifully everything is organized
                  during ISKCON Vijayawada temple festivals...
                </p>
                <NavLink to="/nitya-seva-blog">
                  <button id="read-more-btn">READ MORE</button>
                </NavLink>
              </div>

              <div id="card">
                <div className="image-wrapper-blog">
                  <img src={Ekadashi} alt="Festival" />
                </div>
                <h3>Ekadashi Importance</h3>
                <p>
                  Every month, there is a special day known as Ekadashi that
                  holds great importance for devotees of Lord Vishnu...
                </p>
                <NavLink to="/ekadashi-importance">
                  <button id="read-more-btn">READ MORE</button>
                </NavLink>
              </div>
              <div id="card">
                <div className="image-wrapper-blog">
                  <img src={Radhayatra} alt="Festival" />
                </div>
                <h3>Sri Jagannath Rath Yatra</h3>
                <p>
                  Vijayawada, located on the banks of the Krishna River, is a
                  major cultural and commercial hub in Andhra Pradesh. Known
                  for...
                </p>
                <NavLink to="/sri-jagannath-rath-yatra">
                  <button id="read-more-btn">READ MORE</button>
                </NavLink>
              </div>

             
            </div>
          </div>

          {/* Sidebar */}
          <div id="cards-sidebar-section">
            <RecentBlogs />
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default Blogs;
